<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Forms from "../../../../mixins/Forms";
import axios from 'axios';

/**
 * Tag templates create component
 */
export default {
  page: {
    title: "Create New Tag Template",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {Layout, PageHeader},
  mixins: [Forms],
  data() {
    return {
      title: "Add New Tag Template",
      items: [
        {
          text: "Settings",
          href: "#"
        },
        {
          text: "Add Tag Template",
          active: true
        }
      ],
      form: {
        name: ''
      },
      serverErrors: [],
      isSaving: false
    };
  },
  methods: {
    attemptSave() {
      this.save();
    },

    save() {
      let vm = this;

      vm.isSaving = true;
      axios.post(API_BASE + '/tag-templates', {
        name: vm.form.name
      }).then(r => {
        vm.isSaving = false;
        this.$notify.success({
          title: 'Success!',
          message: 'Tag template created successfully'
        });
        vm.$router.push('/settings/tag-templates/');
      }).catch(e => {
        console.log(e);
        vm.isSaving = false;
        vm.setErrors(e);
      });
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <errors :error-list="serverErrors"></errors>
    <loading-screen :is-loading="isSaving"></loading-screen>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <!--            <h4 class="card-title mb-4">Ticket Details</h4>-->
            <form @submit.prevent="attemptSave">
              <div class="form-group row mb-4">
                <label for="name" class="col-form-label col-lg-2">Name</label>
                <div class="col-lg-10">
                  <input
                      id="name"
                      name="name"
                      type="text"
                      class="form-control"
                      v-model="form.name"
                      autofocus
                  />
                </div>
              </div>
            </form>
            <div class="row justify-content-end">
              <div class="col-lg-10">
                <button type="submit" class="btn btn-itg-dark" @click.prevent="attemptSave">Add Tag Template</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<style scoped>
</style>
